export function hasFocus(node: ParentNode) {
  return node.querySelector(":focus") != null;
}
